import { BRIDGE_HEARTBEAT_SEQ_MAX } from './constants.js';

export function createHeartbeatSeqCursor(): {
  next: () => number;
  reset: () => void;
} {
  let seqCursor = -1;

  return {
    next(): number {
      seqCursor = seqCursor >= BRIDGE_HEARTBEAT_SEQ_MAX ? 0 : seqCursor + 1;
      return seqCursor;
    },
    reset(): void {
      seqCursor = -1;
    },
  };
}
